import { render, staticRenderFns } from "./LoginOAuthRedirect.vue?vue&type=template&id=4e63222b&scoped=true&"
import script from "./LoginOAuthRedirect.vue?vue&type=script&lang=js&"
export * from "./LoginOAuthRedirect.vue?vue&type=script&lang=js&"
import style0 from "./LoginOAuthRedirect.vue?vue&type=style&index=0&id=4e63222b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e63222b",
  null
  
)

export default component.exports